module.exports = __webpack_public_path__ + "img/no_data.06c36322.svg";